module.exports = __webpack_public_path__ + "website/img/core11_1.d08d3dfc.png";